import clsx from 'clsx';

type Provider = 'google' | 'microsoft' | string;

export const getSignInButtonClasses = (provider: Provider): string => {
  return clsx('calendarSignInButton', {
    googleButton: provider === 'google',
    microsoftButton: provider === 'microsoft',
  });
};
